import classnames from 'classnames'

import { InputWrapError, InputWrapHelp } from '../../../Input'
import { SymbolCounter } from '../../../SymbolCounter'

import * as styles from './TextareaInlineFieldWrap.module.css'

function TextareaInlineFieldWrap({
  children,
  className,
  disabled,
  error,
  helpText,
  maxLength,
  ref,
  value,
  withCounter,
}) {
  const textareaInlineFieldWrapClassName = classnames(
    styles.textareaInlineFieldWrap,
    { [styles.disabled]: disabled },
    className
  )

  const showBottomControl =
    (!disabled && error) || (!error && helpText) || withCounter

  return (
    <div className={textareaInlineFieldWrapClassName} ref={ref}>
      {children}
      {showBottomControl ? (
        <div className={styles.bottomControl}>
          {!disabled && error ? <InputWrapError text={error} /> : null}
          {!error && helpText ? <InputWrapHelp text={helpText} /> : null}
          {withCounter ? (
            <SymbolCounter
              className={styles.counter}
              maxLength={maxLength}
              value={value}
            />
          ) : null}
        </div>
      ) : null}
    </div>
  )
}

export default TextareaInlineFieldWrap
